/* Mastichová kalkulačka – komponenta (rozhodnutí 43, maketa https://claude.ai/artifact/8JAeqes5u1wLUyukz9un2q).
 *
 * Stejná komponenta běží na stránce kalkulačky (sekce masticha-kalkulacka, data-mlk-auto) i ve vysouvacím
 * panelu (snippet kalkulacka-panel ji připojí přes MLK_KALK.mount). Data jsou v <script data-mlk-data>
 * uvnitř kořene: katalog, konfigurace z aplikace, texty uzlů (i18n) a texty rozhraní (ui).
 *
 * - Otázky: zodpovězené jsou sbalené řádky s „Změnit“, otevřená je jen aktuální. Stejná odpověď vrátí
 *   zbytek cesty, jiná odpověď zahodí odpovědi pod ní (engine.sanitizujOdpovedi).
 * - Výsledek: konec s produkty (engine.konecSProdukty) nebo starý konec s řadou převedený na stejné karty.
 * - Košík: kalkulačka má v košíku nejvýš jeden svůj řádek (vlastnost _kalkulacka = cesta odpovědí).
 *   Další karty nabízejí „Vyměnit za tento“, ruční položky zůstávají. Zákazník zůstává v kalkulačce,
 *   do šuplíku košíku jde tlačítkem v souhrnu.
 * - Adresa: #kalkulacka-<odpověď>-<odpověď>… (Zpět v prohlížeči, odkaz z košíku), poslední stav i v sessionStorage.
 */
(function () {
  "use strict";

  var VLASTNOST = "_kalkulacka";
  var SESSION = "mlk3";
  var HASH = "#kalkulacka";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }
  function nahrad(sablona, hodnota) { return String(sablona || "").replace("§", hodnota); }

  function mount(root, opts) {
    if (!root) return null;
    if (root.__mlk) return root.__mlk;
    opts = opts || {};
    var engine = window.MLK_ENGINE;
    var dataEl = root.querySelector("script[data-mlk-data]");
    if (!engine || !dataEl) return null;
    var data = JSON.parse(dataEl.textContent);
    var catalog = data.catalog, config = data.config, I18N = data.i18n || {}, UI = data.ui || {};
    var app = root.querySelector("[data-mlk-app]");
    var locale = catalog.locale || document.documentElement.lang || "cs";
    var pravidlaPoctu = window.Intl && Intl.PluralRules ? new Intl.PluralRules(locale) : null;

    var answers = engine.vychoziOdpovedi(config);
    var edit = 0;      /* počet zodpovězených otázek = index otevřené otázky */
    var dosud = 0;     /* nejdál zodpovězená otázka (stejná odpověď ji vrátí) */
    var kosik = { radek: null, pocet: 0, celkem: 0, nacteno: false };
    var zaneprazdneno = false;

    function t18(k) { var v = I18N[k]; return v === undefined || v === null ? "" : v; }
    /* Cena podle shop.money_format (zástupné tvary Shopify: oddělovač tisíců a desetinných míst). */
    var FORMATY = {
      amount: [2, ",", "."], amount_no_decimals: [0, ",", "."], amount_with_comma_separator: [2, ".", ","],
      amount_no_decimals_with_comma_separator: [0, ".", ","], amount_with_apostrophe_separator: [2, "'", "."],
      amount_no_decimals_with_space_separator: [0, " ", ","], amount_with_space_separator: [2, " ", ","],
      amount_with_period_and_space_separator: [2, " ", "."]
    };
    function money(cents) {
      if (cents == null) return "";
      var fmt = catalog.moneyFormat || "{{amount}}";
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, tvar) {
        var f = FORMATY[tvar] || FORMATY.amount;
        var cast = (Math.round(cents) / 100).toFixed(f[0]).split(".");
        return cast[0].replace(/\B(?=(\d{3})+(?!\d))/g, f[1]) + (cast[1] ? f[2] + cast[1] : "");
      }).replace(/<[^>]+>/g, "");
    }
    /* Tvary počtu: vzorky pro 1, 2 a 5 z Liquidu; číslo ve vzorku se nahradí skutečným. */
    function pocet(vzorky, n) {
      if (!vzorky || !vzorky.length) return String(n);
      var kat = pravidlaPoctu ? pravidlaPoctu.select(n) : n === 1 ? "one" : "other";
      var i = kat === "one" ? 0 : kat === "few" ? 1 : 2;
      return String(vzorky[i]).replace(String([1, 2, 5][i]), String(n));
    }
    function track(nazev, d) {
      try {
        var payload = Object.assign({ verze: config.verze }, d || {});
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nazev, payload);
        if (window.dataLayer) window.dataLayer.push({ event: nazev, mlk: payload });
      } catch (e) { /* analytika nesmí shodit kalkulačku */ }
    }

    /* ---------- texty kroků ---------- */
    function textyKroku(k) {
      var kp = k.uzel ? "uzly." + k.uzel + "." : "kroky." + k.id + ".";
      var odp = function (v, pole) { return k.uzel ? kp + "odpovedi." + v + "." + (pole === "b" ? "titulek" : "poznamka") : kp + "volby." + v + "." + pole; };
      return {
        titulek: t18(kp + "titulek"),
        poznamka: k.uzel ? engine.formatujText(t18(kp + "poznamka")) : esc(t18(kp + "podtitulek")),
        volby: engine.aktivniVolby(k).filter(function (v) { return t18(odp(v.v, "b")) !== ""; }).map(function (v) {
          return { v: v.v, ic: v.ic || "", b: t18(odp(v.v, "b")), d: t18(odp(v.v, "d")) };
        })
      };
    }
    function kroky() { return engine.aktivniKroky(config, answers); }
    function hodnotaKroku(k) { var h = answers[k.id]; return Array.isArray(h) ? h : h == null ? [] : [h]; }

    /* ---------- adresa a uložení ---------- */
    function cesta() {
      return kroky().slice(0, edit).map(function (k) { return hodnotaKroku(k).join("+"); }).join("-");
    }
    function zCesty(s) {
      var a = engine.vychoziOdpovedi(config);
      var casti = String(s || "").split("-").filter(Boolean);
      var n = 0;
      for (var i = 0; i < casti.length; i++) {
        var k = engine.aktivniKroky(config, a)[i];
        if (!k) break;
        var hodnoty = casti[i].split("+").filter(function (v) { return engine.aktivniVolby(k).some(function (x) { return x.v === v; }); });
        if (!hodnoty.length) break;
        a[k.id] = k.typ === "multi" ? hodnoty : hodnoty[0];
        a = engine.sanitizujOdpovedi(config, a);
        n++;
      }
      return { answers: a, edit: n };
    }
    function nastavStav(st) { answers = st.answers; edit = st.edit; dosud = st.edit; }
    function uloz() {
      try { sessionStorage.setItem(SESSION, JSON.stringify({ verze: config.verze, cesta: cesta() })); } catch (e) { /* bez úložiště */ }
    }
    function zapisAdresu(novy) {
      var h = HASH + (edit ? "-" + cesta() : "");
      if (location.hash === h) return;
      try { history[novy ? "pushState" : "replaceState"](history.state, "", h); } catch (e) { /* sandbox */ }
    }
    function obnov(hash) {
      if (hash && hash.indexOf(HASH) === 0) { nastavStav(zCesty(hash.slice(HASH.length + 1))); return true; }
      try {
        var s = JSON.parse(sessionStorage.getItem(SESSION) || "null");
        if (s && s.verze === config.verze) { nastavStav(zCesty(s.cesta)); return true; }
      } catch (e) { /* bez úložiště */ }
      return false;
    }

    /* ---------- výsledek: jednotný model karet ---------- */
    function vysledek() {
      var r = engine.doporuc(catalog, config, answers);
      if (r.chyba) return { chyba: r.chyba };
      var m = { id: r.pravidloId, nadpis: "", text: "", davkovani: "", dni: null, produkty: [] };
      if (r.konec) {
        m.dni = r.konec.dni;
        m.produkty = r.konec.produkty.filter(function (p) { return p.baleni.dostupne; });
        m.nadpis = t18("konce." + r.pravidloId + ".nadpis");
        m.davkovani = t18("konce." + r.pravidloId + ".davkovani");
        if (!m.nadpis && m.produkty.length && catalog.rady[m.produkty[0].baleni.rada]) m.nadpis = catalog.rady[m.produkty[0].baleni.rada].nazev;
      } else {
        /* Konec s řadou (před převodem v aplikaci): doporučené balení, alternativa a kombinované kúry. */
        var p = r.primarni;
        var zMoznosti = function (x, kuraDni) {
          return x && x.baleni.dostupne ? { baleni: x.baleni, vydrzDni: x.vydrzDni, kusu: kuraDni ? x.pocetNaKuru : 1, cenaCelkem: (kuraDni ? x.pocetNaKuru || 1 : 1) * x.baleni.cena, cenaNaDen: x.cenaNaDen } : null;
        };
        if (p) {
          m.dni = p.kuraDni || null;
          m.nadpis = p.rada.nazev;
          var davKlic = config.radaDavkovani ? config.radaDavkovani[p.radaKlic] : null;
          var d = davKlic && config.davkovani ? config.davkovani[davKlic] : null;
          var tier = d ? (d.vse ? "vse" : d[r.odpovedi.intensity] ? r.odpovedi.intensity : "standard") : null;
          m.davkovani = tier ? t18("davkovani." + davKlic + "." + tier) : "";
          [zMoznosti(p.vybrane, m.dni)].concat(r.alternativa ? [zMoznosti(r.alternativa.vybrane, r.alternativa.kuraDni)] : [])
            .concat((r.doplnky || []).map(function (x) { return zMoznosti(x, null); }))
            .forEach(function (x) { if (x && !m.produkty.some(function (y) { return y.baleni.id === x.baleni.id; })) m.produkty.push(x); });
        }
      }
      m.text = t18("konce." + r.pravidloId + ".text");
      m.nejnizsi = null;
      m.produkty.forEach(function (x, i) { if (x.cenaNaDen != null && (m.nejnizsi === null || x.cenaNaDen < m.produkty[m.nejnizsi].cenaNaDen)) m.nejnizsi = i; });
      if (m.produkty.length < 2) m.nejnizsi = null;
      return m;
    }

    /* ---------- vykreslení ---------- */
    var IKONA_KOSIK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 7h14l-1.4 11H6.4z M9 7a3 3 0 0 1 6 0"/></svg>';
    var IKONA_DAVKA = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect x="2" y="5.5" width="12" height="5" rx="2.5"/><path d="M8 5.5v5"/></svg>';
    var IKONA_DNY = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect x="2" y="3" width="12" height="11" rx="1.5"/><path d="M2 6.5h12M5 1.5v3M11 1.5v3"/></svg>';

    function htmlHotovo(k, i) {
      var t = textyKroku(k);
      var vybrane = hodnotaKroku(k);
      var odpovedi = t.volby.filter(function (v) { return vybrane.indexOf(v.v) !== -1; });
      return '<div class="mlk__hotovo"><span class="mlk__hotovo-otazka">' + esc(t.titulek) + '</span>' +
        '<span class="mlk__hotovo-odpoved">' + odpovedi.map(function (o) { return (o.ic ? '<span aria-hidden="true">' + esc(o.ic) + "</span>" : "") + esc(o.b); }).join(", ") + "</span>" +
        '<button type="button" class="mlk__zmenit" data-zmenit="' + i + '" aria-label="' + esc(nahrad(UI.changeAnswer, t.titulek)) + '">' + esc(UI.change) + "</button></div>";
    }
    function htmlOtazka(k, i) {
      var t = textyKroku(k);
      var vybrane = hodnotaKroku(k);
      var multi = k.typ === "multi";
      var h = '<div class="mlk__otazka" data-mlk-fokus><p class="mlk__poradi">' + esc(nahrad(UI.question, i + 1)) + "</p>" +
        '<h2 class="mlk__nadpis h3" id="mlk-q-' + esc(k.id) + '" tabindex="-1">' + esc(t.titulek) + "</h2>" +
        (t.poznamka ? '<div class="mlk__poznamka mlk__md">' + t.poznamka + "</div>" : "") +
        '<div class="mlk__volby" role="group" aria-labelledby="mlk-q-' + esc(k.id) + '">';
      t.volby.forEach(function (v) {
        var sel = vybrane.indexOf(v.v) !== -1;
        h += '<button type="button" class="mlk__volba" data-v="' + esc(v.v) + '" ' + (multi ? 'role="checkbox" aria-checked="' + sel + '"' : 'aria-pressed="' + sel + '"') + ">" +
          '<span class="mlk__ikona" aria-hidden="true">' + esc(v.ic) + '</span><span class="mlk__volba-text"><b>' + esc(v.b) + "</b>" +
          (v.d ? '<span class="mlk__md">' + engine.formatujText(v.d, { vTlacitku: true }) + "</span>" : "") + "</span></button>";
      });
      h += "</div>";
      if (multi) h += '<div class="mlk__dal"><button type="button" class="button" data-dal' + (k.povinny && !vybrane.length ? " disabled" : "") + ">" + esc(UI.continue) + "</button></div>";
      return h + "</div>";
    }
    function htmlKarta(m, x, i) {
      var b = x.baleni;
      var radek = kosik.radek;
      var vKosiku = radek && String(radek.variantId) === String(b.variantId);
      var stitky = [];
      if (i === 0) stitky.push('<span class="mlk-karta__stitek mlk-karta__stitek--hlavni">' + esc(UI.recommended) + "</span>");
      if (i === m.nejnizsi) stitky.push('<span class="mlk-karta__stitek">' + esc(UI.cheapest) + "</span>");
      var fakta = m.dni ? "<li>" + esc(pocet(UI.forDays, m.dni)) + ": <b>" + esc(pocet(UI.packs, x.kusu || 1)) + "</b></li>" : "";
      /* Při kúře jen u balení, které kúru přesáhne – jinak by výdrž kratší než kúra mátla. */
      if (x.vydrzDni && (!m.dni || x.vydrzDni > m.dni)) fakta += "<li><b>" + esc(pocet(UI.lasts, x.vydrzDni)) + "</b></li>";
      if (x.cenaNaDen != null) fakta += "<li>" + nahrad(esc(UI.perDay), "<b>" + esc(money(x.cenaNaDen)) + "</b>") + "</li>";
      var akce;
      if (vKosiku) akce = '<span class="mlk-karta__v-kosiku">✓ ' + esc(UI.inCart) + (radek.quantity > 1 ? " " + radek.quantity + "×" : "") + '</span><button type="button" class="mlk__zmenit" data-odebrat>' + esc(UI.remove) + "</button>";
      else if (radek) akce = '<button type="button" class="button button--secondary" data-vymenit="' + i + '">' + esc(UI.swap) + "</button>";
      else akce = '<button type="button" class="button' + (i === 0 ? "" : " button--secondary") + '" data-pridat="' + i + '" aria-label="' + esc(nahrad(UI.addToCartProduct, b.nazev)) + '">' + IKONA_KOSIK + esc(UI.addToCart) + ((x.kusu || 1) > 1 ? " (" + x.kusu + "×)" : "") + "</button>";
      return '<li><div class="mlk-karta' + (vKosiku ? " mlk-karta--v-kosiku" : "") + '">' +
        /* Fotka není odkaz – na produkt se odchází jen názvem (zákazník má zůstat v kalkulačce). */
        '<div class="mlk-karta__foto">' + (b.obrazek ? '<img src="' + esc(b.obrazek) + '" alt="" loading="lazy" width="360" height="270">' : "") +
        (stitky.length ? '<span class="mlk-karta__stitky">' + stitky.join("") + "</span>" : "") + "</div>" +
        '<div class="mlk-karta__telo">' + (stitky.length ? '<span class="mlk-karta__stitky mlk-karta__stitky--telo">' + stitky.join("") + "</span>" : "") +
        '<a class="mlk-karta__nazev" href="' + esc(b.url) + '">' + esc(b.nazev) + "</a>" +
        (fakta ? '<ul class="mlk-karta__fakta">' + fakta + "</ul>" : "") +
        '<div class="mlk-karta__cena"><span class="mlk-karta__castka">' + esc(money(x.cenaCelkem != null ? x.cenaCelkem : b.cena)) +
        ((x.kusu || 1) > 1 ? "<small>" + x.kusu + " × " + esc(money(b.cena)) + "</small>" : "") + "</span>" +
        '<span class="mlk-karta__akce">' + akce + "</span></div></div></div></li>";
    }
    function htmlVysledek(m) {
      if (m.chyba) return '<div class="mlk__vysledek" data-mlk-fokus><p class="mlk__bez">' + esc(UI.noResult) + '</p><div class="mlk__paticka"><span></span><button type="button" class="mlk__zmenit" data-znovu>' + esc(UI.startOver) + "</button></div></div>";
      var h = '<div class="mlk__vysledek" data-mlk-fokus><div><p class="mlk__stitek">' + esc(UI.recommended) + "</p>" +
        '<h2 class="mlk__nadpis h3" tabindex="-1">' + esc(m.nadpis) + "</h2></div>" +
        (m.text ? '<div class="mlk__text">' + engine.formatujText(m.text) + "</div>" : "");
      var cipy = (m.davkovani ? '<span class="mlk__cip">' + IKONA_DAVKA + esc(m.davkovani) + "</span>" : "") +
        '<span class="mlk__cip">' + IKONA_DNY + esc(m.dni ? pocet(UI.courseDays, m.dni) : UI.ongoing) + "</span>";
      h += '<div class="mlk__cipy">' + cipy + "</div>";
      if (m.produkty.length) h += '<ul class="mlk__karty" role="list">' + m.produkty.map(function (x, i) { return htmlKarta(m, x, i); }).join("") + "</ul>";
      else h += '<p class="mlk__vyprodano" role="status">' + esc(UI.soldOut) + "</p>";
      var poradna = data.poradna && window.AdvisorOverlay && typeof window.AdvisorOverlay.open === "function";
      h += '<div class="mlk__paticka"><span>' + (poradna ? esc(UI.askQuestion) + ' <button type="button" class="mlk__zmenit" data-poradna>' + esc(UI.askAdvisor) + "</button>" : "") + "</span>" +
        '<button type="button" class="mlk__zmenit" data-znovu>' + esc(UI.startOver) + "</button></div>";
      if (UI.disclaimer) h += '<p class="mlk__upozorneni">' + esc(UI.disclaimer) + "</p>";
      return h + "</div>";
    }
    function htmlSouhrn() {
      if (!kosik.pocet) return "";
      return '<div class="mlk__souhrn"><span>' + esc(UI.cartLabel) + " <b>" + esc(pocet(UI.cartItems, kosik.pocet)) + "</b> · <b>" + esc(money(kosik.celkem)) + "</b></span>" +
        '<button type="button" class="button" data-do-kosiku>' + esc(UI.goToCart) + "</button></div>";
    }

    var model = null;
    function render(posun) {
      var ks = kroky();
      if (edit > ks.length) edit = ks.length;
      var h = "";
      for (var i = 0; i < ks.length; i++) {
        if (i < edit) h += htmlHotovo(ks[i], i);
        else { h += htmlOtazka(ks[i], i); break; }
      }
      model = edit >= ks.length ? vysledek() : null;
      if (model) h += htmlVysledek(model);
      h += htmlSouhrn() + '<p class="mlk__hlaseni" role="status" data-hlaseni></p>';
      app.innerHTML = h;
      uloz();
      if (posun) {
        var cil = app.querySelector("[data-mlk-fokus]");
        if (cil) {
          var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
          cil.scrollIntoView({ block: "start", behavior: reduce ? "auto" : "smooth" });
          var nadpis = cil.querySelector(".mlk__nadpis");
          if (nadpis) nadpis.focus({ preventScroll: true });
        }
      }
    }
    function ohlas(text) {
      var el = app.querySelector("[data-hlaseni]");
      if (el) { el.textContent = ""; setTimeout(function () { el.textContent = text; }, 30); }
    }

    /* ---------- odpovědi ---------- */
    function vyber(i, v) {
      var ks = kroky();
      var k = ks[i];
      if (!k) return;
      if (k.typ === "multi") {
        var arr = hodnotaKroku(k).slice();
        var j = arr.indexOf(v);
        if (j === -1) arr.push(v); else arr.splice(j, 1);
        answers[k.id] = arr;
        answers = engine.sanitizujOdpovedi(config, answers);
        dosud = i;
        render(false);
        return;
      }
      if (answers[k.id] === v && dosud > i) edit = dosud;
      else {
        answers[k.id] = v;
        answers = engine.sanitizujOdpovedi(config, answers);
        edit = i + 1;
        dosud = edit;
      }
      track("mlk_step", { krok: k.id, volba: v });
      zapisAdresu(true);
      render(true);
      if (edit >= kroky().length && model && !model.chyba) track("mlk_result", { konec: model.id, produkty: model.produkty.map(function (x) { return x.baleni.sku || x.baleni.id; }) });
    }

    /* ---------- košík ---------- */
    function routes() {
      var r = window.routes || {};
      return { add: (r.cart_add_url || "/cart/add") + ".js", change: (r.cart_change_url || "/cart/change") + ".js", cart: (r.cart_url || data.cartUrl || "/cart") };
    }
    function nactiKosik() {
      return fetch(routes().cart + ".js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (c) {
        var radek = null;
        (c.items || []).forEach(function (it) { if (!radek && it.properties && it.properties[VLASTNOST]) radek = { key: it.key, variantId: it.variant_id, quantity: it.quantity, cesta: it.properties[VLASTNOST] }; });
        kosik = { radek: radek, pocet: c.item_count || 0, celkem: c.total_price || 0, nacteno: true };
      });
    }
    function sekce(ids) {
      return fetch((data.rootUrl || "/").replace(/\/?$/, "/") + "?sections=" + ids.join(","), { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
    }
    function obnovIkonuKosiku() {
      return sekce(["cart-icon-bubble"]).then(function (s) {
        var el = document.getElementById("cart-icon-bubble");
        if (!el || !s["cart-icon-bubble"]) return;
        var novy = new DOMParser().parseFromString(s["cart-icon-bubble"], "text/html").querySelector(".shopify-section");
        if (novy) el.innerHTML = novy.innerHTML;
      }).catch(function () { /* ikona počká na další načtení */ });
    }
    function odesli(url, telo) {
      return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(telo) })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); });
    }
    function zmenKosik(krok, hlaseni) {
      if (zaneprazdneno) return;
      zaneprazdneno = true;
      var karty = app.querySelectorAll(".mlk-karta");
      karty.forEach(function (k) { k.setAttribute("aria-busy", "true"); });
      krok().then(nactiKosik).then(function () {
        zaneprazdneno = false;
        render(false);
        ohlas(hlaseni);
        obnovIkonuKosiku();
        document.dispatchEvent(new CustomEvent("mlk:kosik", { detail: kosik }));
      }).catch(function () {
        zaneprazdneno = false;
        render(false);
        ohlas(UI.cartError);
      });
    }
    function pridej(i) {
      var x = model && model.produkty[i];
      if (!x) return;
      track("mlk_add_to_cart", { variant: x.baleni.variantId, mnozstvi: x.kusu || 1, konec: model.id });
      zmenKosik(function () { return odesli(routes().add, { items: [{ id: Number(x.baleni.variantId), quantity: x.kusu || 1, properties: polozkaVlastnosti() }] }); }, UI.added);
    }
    function polozkaVlastnosti() { var p = {}; p[VLASTNOST] = cesta(); return p; }
    function vymen(i) {
      var x = model && model.produkty[i];
      var radek = kosik.radek;
      if (!x || !radek) return;
      zmenKosik(function () {
        return odesli(routes().change, { id: radek.key, quantity: 0 }).then(function () {
          return odesli(routes().add, { items: [{ id: Number(x.baleni.variantId), quantity: x.kusu || 1, properties: polozkaVlastnosti() }] });
        });
      }, UI.swapped);
    }
    function odeber() {
      var radek = kosik.radek;
      if (!radek) return;
      zmenKosik(function () { return odesli(routes().change, { id: radek.key, quantity: 0 }); }, UI.removed);
    }
    function doKosiku() {
      var drawer = document.querySelector("cart-drawer");
      if (!drawer || typeof drawer.renderContents !== "function") { location.href = routes().cart; return; }
      sekce(["cart-drawer", "cart-icon-bubble"]).then(function (s) {
        if (opts.zavrit) opts.zavrit({ bezHistorie: false });
        drawer.renderContents({ sections: s });
      }).catch(function () { location.href = routes().cart; });
    }

    /* ---------- události ---------- */
    app.addEventListener("click", function (e) {
      var t = e.target.closest("button");
      if (!t || !app.contains(t)) return;
      if (t.hasAttribute("data-v")) {
        var ks = kroky();
        vyber(Math.min(edit, ks.length - 1), t.getAttribute("data-v"));
      } else if (t.hasAttribute("data-dal")) {
        edit = edit + 1; dosud = edit; zapisAdresu(true); render(true);
      } else if (t.hasAttribute("data-zmenit")) {
        edit = Number(t.getAttribute("data-zmenit")); render(true);
      } else if (t.hasAttribute("data-pridat")) pridej(Number(t.getAttribute("data-pridat")));
      else if (t.hasAttribute("data-vymenit")) vymen(Number(t.getAttribute("data-vymenit")));
      else if (t.hasAttribute("data-odebrat")) odeber();
      else if (t.hasAttribute("data-do-kosiku")) doKosiku();
      else if (t.hasAttribute("data-znovu")) {
        answers = engine.vychoziOdpovedi(config); edit = 0; dosud = 0; zapisAdresu(true); render(true);
      } else if (t.hasAttribute("data-poradna")) {
        if (opts.zavrit) opts.zavrit({ bezHistorie: false });
        try { window.AdvisorOverlay.open(); } catch (err) { /* poradna nedostupná */ }
      }
    });
    function zAdresy() {
      if (location.hash.indexOf(HASH) !== 0) return;
      nastavStav(zCesty(location.hash.slice(HASH.length + 1)));
      var drawer = document.querySelector("cart-drawer");
      if (drawer && drawer.classList.contains("active") && typeof drawer.close === "function") drawer.close();
      render(true);
    }
    /* Stránka: změna adresy (Zpět, odkaz z košíku na téže stránce). Panel: Zpět v prohlížeči (pushState). */
    if (opts.panel) window.addEventListener("popstate", zAdresy);
    else window.addEventListener("hashchange", zAdresy);

    var api = {
      /* Panel: otevření s cestou z odkazu (nebo poslední stav). */
      otevri: function (hash) { if (hash && hash.indexOf(HASH) === 0) nastavStav(zCesty(hash.slice(HASH.length + 1))); zapisAdresu(true); render(true); nactiKosik().then(function () { render(false); }).catch(function () {}); },
      adresa: function () { return HASH + (edit ? "-" + cesta() : ""); }
    };
    root.__mlk = api;

    obnov(opts.hash !== undefined ? opts.hash : location.hash);
    render(false);
    if (location.hash.indexOf(HASH) === 0 && !opts.panel) render(true);
    nactiKosik().then(function () { render(false); }).catch(function () { /* košík se načte při další akci */ });
    track("mlk_start", { panel: Boolean(opts.panel) });
    return api;
  }

  window.MLK_KALK = { mount: mount };
  document.querySelectorAll("[data-mlk-root][data-mlk-auto]").forEach(function (el) {
    if (!el.closest("[data-mlk-panel]")) mount(el, {});
  });
})();
